export default {
  serverURI: [
    'https://webtoprint.me/app/',
    process.env.VUE_APP_API_URL || 'http://localhost/web-to-print-old/app/',
  ],
  swalTimer: 800,
};
